import { Action, TemplateDeploymentState } from "types/generated";
import { AccessResult, EntityWithAllowedActions, NO_ACCESS_MESSAGE } from "utils/access";

const isDeploymentDeleteDisabled = (state: TemplateDeploymentState): boolean => {
  return [
    TemplateDeploymentState.InProgress,
    TemplateDeploymentState.Unconfirmed,
    TemplateDeploymentState.None,
  ].includes(state);
};

const getDeleteDisabledMessage = (state: TemplateDeploymentState): string | undefined => {
  switch (state) {
    case TemplateDeploymentState.InProgress:
      return "Cannot delete deployment while it is in progress";
    case TemplateDeploymentState.Unconfirmed:
      return "Cannot delete deployment while it is unconfirmed";
    case TemplateDeploymentState.None:
      return "Cannot delete deployment while it is in progress";
    case TemplateDeploymentState.Destroying:
    case TemplateDeploymentState.DestroyingFailed:
    case TemplateDeploymentState.Discarded:
    case TemplateDeploymentState.Failure:
    case TemplateDeploymentState.Finished:
      return undefined;
  }
};

type DeploymentWithState = EntityWithAllowedActions & { state: TemplateDeploymentState };

export const canDeleteDeployment = (deployment: DeploymentWithState): AccessResult => {
  if (!deployment.allowedActions.includes(Action.DeleteBlueprintDeployment)) {
    return { result: false, message: NO_ACCESS_MESSAGE };
  }

  if (isDeploymentDeleteDisabled(deployment.state)) {
    const message = getDeleteDisabledMessage(deployment.state);
    return { result: false, message };
  }

  return { result: true };
};
